
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { ApiServiceERP } from '../../../apis/ApiServiceERP';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Subscription } from 'rxjs';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormatDataTableGlobal } from 'src/app/web/util/formatDataTable';
import { ErrorService } from 'src/app/shared/services/errors.service';



export class ListHeadquarter {

  id: number;
  name:string;
  customers_id:number;  
  }
  
  


export class listClient {
  
  id: number;
  name_client: string;
  user_id:number
  listHeadquarter:
    {
    
    };
  listFrente:
    {
      name: string;
    };

}

export class infolistClient {

  id: number;
  name: string;


}


@Component({
  selector: 'app-edit-client',
  templateUrl: './edit-client.component.html',
  styleUrls: ['./edit-client.component.scss']
})
export class EditClientComponent implements AfterViewInit, OnDestroy, OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtOptions2: DataTables.Settings = {};
  annex: any[] = []
  annexForm: FormGroup;
  step: number = 0
  datos: listClient;
  datos2: any[] = [];
  listHeadquarter: any[] = [];
  title = "Datos"
  id_client: 0;
  listUser: any[] = [];
  createClient: listClient;
  items!: FormArray;
  paymentsform: FormGroup;
  editClientForm: FormGroup;
  createClientForm: FormGroup;
  idSubscription: Subscription;
  id: 0;
  permiso: number[] = []

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private apiService: ApiServiceERP,
    private errorService:ErrorService

  ) {
    this.route.params.subscribe((params) => {
      this.id = params['id'];

    });
  }

  ngOnInit(): void {
    // this.permiso = this.errorService.getPermisses();
    // if (this.permiso.find(element => element == 16)) {
    // }  else {
    //   this.errorService.error2(403)
    //   this.spinner.hide();
    // }
    this.editClientForm = this.fb.group({
      id: [0],
      name: [''],
      listHeadquarter: [''],
    });

    this.paymentsform = this.fb.group({
      items: new FormArray([])
    });

   
    this.dtOptions = FormatDataTableGlobal();
    this.apiService = new ApiServiceERP(this.http);
    
    this.createClientForm = this.fb.group({
      name_client: [''],
      listHeadquarter: [],
      user_id: [null],
    });

    this.spinner.show();
    this.apiService.getService('client-list').subscribe({
      next: (rs: any) => {
        this.spinner.hide();
        rs.map((dato) => {
          if (dato.id == this.id) {

            this.serviceListUser(dato.user_id)
            this.createClientForm.patchValue({
              name_client: dato.name,
            });

            dato.listHeadquarter.map((dato2) => {
              this.items = this.paymentsform.get("items") as FormArray

              let info = this.fb.group({
                id: dato2.id,
                name: dato2.name,
              });

              this.items.push(info)

            })


          }

        });



      },
      error: (error) => {
        this.errorService.error(error);
      },
    });


  }

  async serviceListUser(idUser){
  
          this.apiService.getService('user-list').subscribe({
            next: (rs:any) => {
              if (rs.code == null) {
                // si la respuesta no tiene error pero no tiene data se manda un mensaje de error y se retorna al home
                if (rs == '' || rs == null) {
                  this.spinner.hide();
                  Swal.fire({
                    title: 'No se encontraron registros',
                    text: '',
                    icon: 'info',
                    confirmButtonText: 'Aceptar',
                    heightAuto: false
                  }).then((res) => {
                    if (res.isConfirmed || res.isDismissed) {
                    }
                  });
                }
                this.listUser = rs
                 this.createClientForm.patchValue({
                  user_id: idUser
                });

                this.spinner.hide();
              } else {
                this.spinner.hide();
                Swal.fire({
                  title:  rs.error,
                  text: '',
                  icon: 'error',
                  heightAuto: false
                  });
              }
            },
            error: (error) => {
              this.errorService.error(error);
            },
          });
    }

  eliminarCampo(index) {

    if(this.items.value[index].id != null){
      this.spinner.show();
    this.apiService.deleteService('client-delete-headquarter?id='+this.items.value[index].id)
      .subscribe({
        next: (data: any) => {
          if(data.code == null){
            this.spinner.hide();
            Swal.fire({title:data.message,text: '',icon: 'success',heightAuto: false})
              .then(() => [
                this.items.removeAt(index)
              ]);
          }else{
            this.spinner.hide();
          Swal.fire(          {
            title: data.error,
            text: '',
            icon: 'error',
            heightAuto: false
          });
          }
        },
        error: (error) => {
          this.errorService.error(error);
        }
      });
    }else{
      this.items.removeAt(index)

    }

  }

  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {

  }

  rerender(): void {


  }

  nuevoCampo() {
    this.items = this.paymentsform.get("items") as FormArray
    let info = this.fb.group({
      name: "",
    });

    this.items.push(info)

  }

  formSubmit(): void {

    if(this.createClientForm.value.name_client == ""){
      Swal.fire({title:"Debe selecciona un nombre" ,text: '',icon: 'error',heightAuto: false});
      return;
    }

     if(this.createClientForm.value.user_id == null){
          Swal.fire({title:"Debe selecciona un lider" ,text: '',icon: 'error',heightAuto: false});
          return;
        }
    
    if(this.items.value.find(x => x.name == "")){
      Swal.fire({title:"Todas las sucursales deben contener el nombre" ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    this.spinner.show();



    this.createClient = this.createClientForm.value;
    this.createClient.id = Number(this.id);
    this.createClient.name_client = this.createClientForm.value.name_client;
    this.createClient.listHeadquarter = this.items.value;
    this.createClient.user_id = this.createClientForm.value.user_id;


    this.apiService.putUpdate('client-update', this.createClient)
      .subscribe({
        next: (data: any) => {
          this.spinner.hide();
          Swal.fire({title:'Se ha actualizado correctamente',text: '',icon: 'success',heightAuto: false})
            .then(() => [
            ]);
           this.router.navigate(['/pdg/client/list']);
        },
        error: (error) => {
          this.errorService.error(error);
        }
      });
  }
}
